import { AuthContext } from '../AuthProvider'
import React from 'react'
import Proptypes from 'prop-types'

const WithUser = Component => {
  return function PropsReceiver(props) {
    return (
      <AuthContext.Consumer>
        {({ user, ...rest }) => {
          return (
            (user && <Component user={user} {...props} {...rest} />) || null
          )
        }}
      </AuthContext.Consumer>
    )
  }
}

WithUser.propTypes = {
  Component: Proptypes.node.isRequired
}

export default WithUser



// WEBPACK FOOTER //
// ./src/components/HOC/withUser.jsx